<script setup lang="ts">
import { computed } from "vue";
import { definePage } from "unplugin-vue-router/runtime";
import { useAbility } from "@/api/models/auth/ability";
import { useMsoSubscriptionIntervalHistory } from "@/composables/models/billing/useSubscriptionIntervalHistory";
import SubscriptionIntervalsSection from "@/components/models/billing/SubscriptionIntervalsSection.vue";
import IntervalsSection from "@/components/models/company/detail/IntervalsSection.vue";
import BillingShell from "@/components/models/billing/BillingShell.vue";
import { canOpenBillingPage, readBillingRights } from "@/composables/shared/billingAccess";
import { useBillingOwner } from "@/composables/shared/useBillingOwner";

definePage({
  meta: {
    title: "features.billing.intervals.title",
    checkPrivileges: () => {
      const { can } = useAbility();
      return canOpenBillingPage(readBillingRights(can), "intervals");
    },
  },
});

const { scope, activeMso } = useBillingOwner();
const msoId = computed(() => (scope.value === "mso" ? activeMso.value?.id : undefined));
const { intervals, productNameById, isLoading } = useMsoSubscriptionIntervalHistory(msoId);
</script>

<template>
  <billing-shell page="intervals">
    <template #default="{ scope: ownerScope, company }">
      <subscription-intervals-section
        v-if="ownerScope === 'mso'"
        :intervals="intervals"
        :product-name-by-id="productNameById"
        :is-loading="isLoading"
      />

      <intervals-section
        v-else-if="ownerScope === 'company' && company"
        :key="`company-${company.id}`"
        :company="company"
      />
    </template>
  </billing-shell>
</template>
